const API_URL = "https://api-kyb-web-h7ghg6hse3hrd8e9.brazilsouth-01.azurewebsites.net";

export interface EmpresaDto {
  empresaId: number;
  nombre: string;
  ultimoAcceso: string | null;
  grupoEmpresaId: number | null;
}

export interface GrupoEmpresaDto {
  grupoEmpresaId: number;
  nombre: string;
  rol: string;
}

export interface LoginData {
  token: string;
  nombre: string;
  email: string;
  usuarioId: number;
  empresas: EmpresaDto[];
  grupos: GrupoEmpresaDto[];
  esSuperUsuario: boolean;
}

export async function login(email: string, password: string): Promise<LoginData> {
  const response = await fetch(`${API_URL}/api/Auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    throw new Error("Credenciales incorrectas");
  }

  return response.json();
}

export interface AccesosDto {
  empresas: EmpresaDto[];
  grupos: GrupoEmpresaDto[];
}

export async function getMisAccesos(usuarioId: number, token: string): Promise<AccesosDto | null> {
  const response = await fetch(`${API_URL}/api/Auth/mis-accesos?usuarioId=${usuarioId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return null;
  return response.json();
}

export async function seleccionarEmpresa(usuarioId: number, empresaId: number, token: string) {
  await fetch(`${API_URL}/api/Auth/seleccionar-empresa`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ usuarioId, empresaId }),
  });
}
export async function getPermisos(usuarioId: number, empresaId: number, token: string): Promise<string[]> {
  const response = await fetch(`${API_URL}/api/Permisos/${usuarioId}/${empresaId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });

  if (!response.ok) return [];

  return response.json();
}
export interface PlanDeCuentas {
  planesDeCuentasId: number;
  empresaId: number;
  codContable: string;
  nomRubro: string;
  titRubro: string | null;
  imputable: boolean;
  natRubro: number;
  txtRubro: string | null;
  reglaDifCam: number | null;
  codConsol: string | null;
  dhPredet: string | null;
  monBase: string | null;
  difCamPr: boolean;
  difCamSe: boolean;
  nvlRubro: number;
}

export async function getPlanDeCuentas(empresaId: number, token: string): Promise<PlanDeCuentas[]> {
  const response = await fetch(`${API_URL}/api/PlanDeCuentas/${empresaId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}
export async function actualizarCuenta(id: number, cuenta: PlanDeCuentas, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/PlanDeCuentas/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(cuenta),
  });
  return response.ok;
}
export async function eliminarCuenta(id: number, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/PlanDeCuentas/${id}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  const texto = await response.text();
  return { ok: false, mensaje: texto };
}

export async function crearCuenta(cuenta: PlanDeCuentas, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/PlanDeCuentas`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(cuenta),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  const texto = await response.text();
  return { ok: false, mensaje: texto };
}
export interface Moneda {
  monedaId: number;
  empresaId: number;
  nombre: string;
  codigo: string;
  simbolo: string | null;
  decimales: number;
  relacion: string | null;
  monRelac: number | null;
  dcGanGrav: string | null;
  dcGanNoGrav: string | null;
  dcPerdGrav: string | null;
  dcPerdNoGrav: string | null;
  fuenteDescarga: string | null;
  monedaFuente: string | null;
  compVent: string | null;
  diaAnter: number | null;
}

export interface Cotizacion {
  cotizacionId: number;
  empresaId: number;
  codigo: string;
  fecha: string;
  cotizacion_: number;
}

export async function getMonedas(empresaId: number, token: string): Promise<Moneda[]> {
  const response = await fetch(`${API_URL}/api/Monedas/${empresaId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function crearMoneda(moneda: Moneda, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Monedas`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(moneda),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function actualizarMoneda(id: number, moneda: Moneda, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Monedas/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(moneda),
  });
  return response.ok;
}

export async function eliminarMoneda(id: number, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Monedas/${id}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function getCotizaciones(empresaId: number, codigo: string, token: string): Promise<Cotizacion[]> {
  const response = await fetch(`${API_URL}/api/Cotizaciones/${empresaId}/${codigo}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function crearCotizacion(cotizacion: Cotizacion, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Cotizaciones`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(cotizacion),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function eliminarCotizacion(id: number, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Cotizaciones/${id}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

// ===== Usuarios =====

export interface UsuarioListDto {
  usuarioId: number;
  email: string;
  nombre: string;
  activo: boolean;
  esSuperUsuario: boolean;
}

export interface UsuarioEmpresaAsignada {
  empresaId: number;
  nombre: string;
  rol: string;
  activo: boolean;
}

export interface UsuarioGrupoAsignado {
  grupoEmpresaId: number;
  nombre: string;
  rol: string;
  activo: boolean;
}

export interface UsuarioDetailDto {
  usuarioId: number;
  email: string;
  nombre: string;
  activo: boolean;
  esSuperUsuario: boolean;
  empresas: UsuarioEmpresaAsignada[];
  grupos: UsuarioGrupoAsignado[];
}

export interface EmpresaResumen {
  empresaId: number;
  nombre: string;
}

export interface GrupoEmpresaResumen {
  grupoEmpresaId: number;
  nombre: string;
}

export interface ListasApoyo {
  empresas: EmpresaResumen[];
  grupos: GrupoEmpresaResumen[];
}

export interface UsuarioBusquedaDto {
  usuarioId: number;
  email: string;
  nombre: string;
  esSuperUsuario: boolean;
}

// ===== Vista con contexto =====

export interface UsuarioContextoListDto {
  usuarioId: number;
  email: string;
  nombre: string;
  usuarioActivo: boolean;
  esSuperUsuario: boolean;
  membresiaActiva: boolean;
  rolEnContexto: string | null;
}

export interface UsuariosContextoResponse {
  alcance: "Superusuario" | "GroupAdmin" | "EmpresaAdmin" | string;
  grupoEmpresaId: number | null;
  empresaId: number | null;
  usuarios: UsuarioContextoListDto[];
}

export async function getUsuariosContexto(
  solicitanteId: number,
  opts: { grupoId?: number | null; empresaId?: number | null; estado?: string; busqueda?: string },
  token: string
): Promise<UsuariosContextoResponse | null> {
  const params = new URLSearchParams();
  params.set("solicitanteId", String(solicitanteId));
  if (opts.grupoId) params.set("grupoId", String(opts.grupoId));
  if (opts.empresaId) params.set("empresaId", String(opts.empresaId));
  params.set("estado", opts.estado || "todos");
  if (opts.busqueda) params.set("busqueda", opts.busqueda);

  const response = await fetch(`${API_URL}/api/Usuarios/contexto?${params.toString()}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return null;
  return response.json();
}

export async function buscarUsuarios(query: string, token: string): Promise<UsuarioBusquedaDto[]> {
  const response = await fetch(`${API_URL}/api/Usuarios/buscar?query=${encodeURIComponent(query)}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function getUsuarios(token: string): Promise<UsuarioListDto[]> {
  const response = await fetch(`${API_URL}/api/Usuarios`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function getUsuario(id: number, token: string): Promise<UsuarioDetailDto | null> {
  const response = await fetch(`${API_URL}/api/Usuarios/${id}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return null;
  return response.json();
}

export async function getListasApoyoUsuarios(
  token: string,
  solicitanteId?: number,
  grupoId?: number | null
): Promise<ListasApoyo> {
  const params = new URLSearchParams();
  if (solicitanteId) params.set("solicitanteId", String(solicitanteId));
  if (grupoId) params.set("grupoId", String(grupoId));
  const response = await fetch(`${API_URL}/api/Usuarios/listas-apoyo?${params.toString()}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return { empresas: [], grupos: [] };
  return response.json();
}

export async function crearUsuario(
  data: { email: string; nombre: string; password: string; activo: boolean; esSuperUsuario: boolean; grupoEmpresaId?: number | null },
  token: string
): Promise<{ ok: boolean; mensaje: string; usuario?: UsuarioDetailDto }> {
  const response = await fetch(`${API_URL}/api/Usuarios`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (response.ok) return { ok: true, mensaje: "", usuario: await response.json() };
  return { ok: false, mensaje: await response.text() };
}

export async function actualizarUsuario(
  id: number,
  data: { nombre: string; activo: boolean; esSuperUsuario: boolean; password?: string },
  token: string
): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Usuarios/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  return response.ok;
}

export async function desactivarUsuario(id: number, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Usuarios/${id}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  return response.ok;
}

export async function eliminarUsuarioDefinitivo(
  id: number, solicitanteId: number, token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Usuarios/${id}/definitivo?solicitanteId=${solicitanteId}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function asignarEmpresaAUsuario(
  usuarioId: number, empresaId: number, rol: string, activo: boolean, token: string
): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/empresas`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ empresaId, rol, activo }),
  });
  return response.ok;
}

export async function actualizarRolEmpresaUsuario(usuarioId: number, empresaId: number, rol: string, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/empresas/${empresaId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ empresaId, rol }),
  });
  return response.ok;
}

export async function toggleActivoEmpresaUsuario(usuarioId: number, empresaId: number, activo: boolean, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/empresas/${empresaId}/activo`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ activo }),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function quitarEmpresaUsuario(usuarioId: number, empresaId: number, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/empresas/${empresaId}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  return response.ok;
}

export async function asignarGrupoAUsuario(usuarioId: number, grupoEmpresaId: number, rol: string, activo: boolean, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/grupos`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ grupoEmpresaId, rol, activo }),
  });
  return response.ok;
}

export async function actualizarRolGrupoUsuario(usuarioId: number, grupoEmpresaId: number, rol: string, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/grupos/${grupoEmpresaId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ grupoEmpresaId, rol }),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function toggleActivoGrupoUsuario(usuarioId: number, grupoEmpresaId: number, activo: boolean, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/grupos/${grupoEmpresaId}/activo`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ activo }),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function quitarGrupoUsuario(usuarioId: number, grupoEmpresaId: number, token: string): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Usuarios/${usuarioId}/grupos/${grupoEmpresaId}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

// ===== Roles (Accesos y permisos, dentro de una empresa) =====

export interface RolListDto {
  rolId: number;
  nombre: string;
  descripcion: string | null;
  activo: boolean;
  cantidadFunciones: number;
  cantidadUsuarios: number;
}

export interface FuncionCatalogoDto {
  funcionId: number;
  pantalla: string;
  objeto: string;
  accion: string;
  descripcion: string | null;
}

export interface UsuarioEnRolDto {
  usuarioId: number;
  nombre: string;
  email: string;
}

export interface RolDetailDto {
  rolId: number;
  nombre: string;
  descripcion: string | null;
  activo: boolean;
  empresaId: number;
  funcionIds: number[];
  usuarios: UsuarioEnRolDto[];
}

export async function getRoles(empresaId: number, solicitanteId: number, token: string, estado: string = "todos"): Promise<RolListDto[] | null> {
  const response = await fetch(`${API_URL}/api/Roles/empresa/${empresaId}?solicitanteId=${solicitanteId}&estado=${estado}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return null;
  return response.json();
}

export async function getRol(rolId: number, solicitanteId: number, token: string): Promise<RolDetailDto | null> {
  const response = await fetch(`${API_URL}/api/Roles/${rolId}?solicitanteId=${solicitanteId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return null;
  return response.json();
}

export async function getCatalogoFunciones(token: string): Promise<FuncionCatalogoDto[]> {
  const response = await fetch(`${API_URL}/api/Roles/funciones-catalogo`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function crearRol(
  data: { solicitanteId: number; empresaId: number; nombre: string; descripcion?: string },
  token: string
): Promise<{ ok: boolean; mensaje: string; rol?: RolDetailDto }> {
  const response = await fetch(`${API_URL}/api/Roles`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (response.ok) return { ok: true, mensaje: "", rol: await response.json() };
  return { ok: false, mensaje: await response.text() };
}

export async function actualizarRol(
  id: number,
  data: { solicitanteId: number; nombre: string; descripcion?: string; activo: boolean },
  token: string
): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Roles/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  return response.ok;
}

export async function setFuncionesRol(rolId: number, solicitanteId: number, funcionIds: number[], token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Roles/${rolId}/funciones`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ solicitanteId, funcionIds }),
  });
  return response.ok;
}

export async function agregarUsuarioARol(rolId: number, usuarioId: number, solicitanteId: number, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Roles/${rolId}/usuarios/${usuarioId}?solicitanteId=${solicitanteId}`, {
    method: "POST",
    headers: { "Authorization": `Bearer ${token}` }
  });
  return response.ok;
}

export async function quitarUsuarioDeRol(rolId: number, usuarioId: number, solicitanteId: number, token: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/Roles/${rolId}/usuarios/${usuarioId}?solicitanteId=${solicitanteId}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  return response.ok;
}
// ===== Permisos directos por usuario =====

export async function getFuncionesDirectas(
  usuarioId: number, empresaId: number, solicitanteId: number, token: string
): Promise<number[]> {
  const response = await fetch(
    `${API_URL}/api/PermisosDirectos/${usuarioId}/${empresaId}?solicitanteId=${solicitanteId}`,
    { headers: { "Authorization": `Bearer ${token}` } }
  );
  if (!response.ok) return [];
  return response.json();
}

export async function setFuncionesDirectas(
  usuarioId: number, empresaId: number, solicitanteId: number,
  funcionIds: number[], token: string
): Promise<boolean> {
  const response = await fetch(
    `${API_URL}/api/PermisosDirectos/${usuarioId}/${empresaId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify({ solicitanteId, funcionIds }),
    }
  );
  return response.ok;
}

// ===== Empresas (listado y borrado, exclusivo Superusuario) =====

export interface EmpresaListItem {
  empresaId: number;
  nombre: string;
  rut: string | null;
  activo: boolean;
  grupoEmpresaId: number | null;
  grupoEmpresaNombre: string | null;
}

export async function getEmpresasTodas(solicitanteId: number, token: string): Promise<EmpresaListItem[]> {
  const response = await fetch(`${API_URL}/api/Empresas?solicitanteId=${solicitanteId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function crearEmpresa(
  solicitanteId: number,
  data: { nombre: string; grupoEmpresaId?: number | null },
  token: string
): Promise<{ ok: boolean; mensaje: string; empresa?: EmpresaListItem }> {
  const response = await fetch(`${API_URL}/api/Empresas?solicitanteId=${solicitanteId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (response.ok) return { ok: true, mensaje: "", empresa: await response.json() };
  return { ok: false, mensaje: await response.text() };
}

export async function eliminarEmpresa(
  id: number, solicitanteId: number, token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/Empresas/${id}?solicitanteId=${solicitanteId}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

// ===== Grupos de Empresas (CRUD, exclusivo Superusuario) =====

export interface GrupoEmpresaListItem {
  grupoEmpresaId: number;
  nombre: string;
  descripcion: string | null;
  activo: boolean;
  fechaCreacion: string;
  cantidadEmpresas: number;
}

export interface GrupoEmpresaDetalle {
  grupoEmpresaId: number;
  nombre: string;
  descripcion: string | null;
  activo: boolean;
  fechaCreacion: string;
  empresas: EmpresaResumen[];
  empresasDisponibles: EmpresaResumen[];
}

export async function getGruposEmpresas(solicitanteId: number, token: string): Promise<GrupoEmpresaListItem[]> {
  const response = await fetch(`${API_URL}/api/GrupoEmpresas?solicitanteId=${solicitanteId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return [];
  return response.json();
}

export async function getGrupoEmpresa(id: number, solicitanteId: number, token: string): Promise<GrupoEmpresaDetalle | null> {
  const response = await fetch(`${API_URL}/api/GrupoEmpresas/${id}?solicitanteId=${solicitanteId}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (!response.ok) return null;
  return response.json();
}

export async function crearGrupoEmpresa(
  solicitanteId: number,
  data: { nombre: string; descripcion?: string },
  token: string
): Promise<{ ok: boolean; mensaje: string; grupo?: GrupoEmpresaListItem }> {
  const response = await fetch(`${API_URL}/api/GrupoEmpresas?solicitanteId=${solicitanteId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (response.ok) return { ok: true, mensaje: "", grupo: await response.json() };
  return { ok: false, mensaje: await response.text() };
}

export async function actualizarGrupoEmpresa(
  id: number,
  solicitanteId: number,
  data: { nombre: string; descripcion?: string },
  token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/GrupoEmpresas/${id}?solicitanteId=${solicitanteId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(data),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function toggleActivoGrupoEmpresa(
  id: number, solicitanteId: number, activo: boolean, token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/GrupoEmpresas/${id}/activo?solicitanteId=${solicitanteId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ activo }),
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function eliminarGrupoEmpresa(
  id: number, solicitanteId: number, token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(`${API_URL}/api/GrupoEmpresas/${id}?solicitanteId=${solicitanteId}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` }
  });
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function asociarEmpresaAGrupo(
  grupoEmpresaId: number, empresaId: number, solicitanteId: number, token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(
    `${API_URL}/api/GrupoEmpresas/${grupoEmpresaId}/empresas/${empresaId}?solicitanteId=${solicitanteId}`,
    { method: "PUT", headers: { "Authorization": `Bearer ${token}` } }
  );
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}

export async function desasociarEmpresaDeGrupo(
  grupoEmpresaId: number, empresaId: number, solicitanteId: number, token: string
): Promise<{ ok: boolean; mensaje: string }> {
  const response = await fetch(
    `${API_URL}/api/GrupoEmpresas/${grupoEmpresaId}/empresas/${empresaId}?solicitanteId=${solicitanteId}`,
    { method: "DELETE", headers: { "Authorization": `Bearer ${token}` } }
  );
  if (response.ok) return { ok: true, mensaje: "" };
  return { ok: false, mensaje: await response.text() };
}